function gallery() {
  $(document).ready(function() {
    var gallery = $('.photoswipe-gallery');

    if (gallery.length) {
      gallery.masonry({
        itemSelector: '.field__item',
        // fitWidth: true,
        // horizontalOrder: true,
        // originTop: true,
        // originLeft: true,
        containerStyle: { position: 'relative' }
      });
    }
  });
}
